const transform = (list) => {
  if (list) {
    const addName = (child, name) => {
      child.name = name
      child.child = {}
      return child.child
    }

    let foldersName = {}
    let child = foldersName
    list.forEach(f => {
      child = addName(child, f)
    })
    return foldersName
  }
  return null
}

export default transform



// WEBPACK FOOTER //
// ./src/views/private/operational/documents/components/foldersname/transform.js